import type { ReactNode } from 'react'

import Button from '@components/atoms/Button'
import { type ButtonStyleProps } from '@components/atoms/ButtonStyles'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@components/atoms/DropdownMenu'
import cn from '@components/utils/cn'
import { type IconTypes } from '@components/utils/Icon'

export type SplitButtonProps = Pick<ButtonStyleProps, 'rank' | 'color' | 'size'> & {
  label: ReactNode
  onClick: () => void
  leadingIcon?: IconTypes
  ariaLabel?: string
  menuAriaLabel: string
  children: ReactNode
  className?: string
  modal?: boolean
}

export function SplitButton({
  rank,
  color,
  size,
  label,
  onClick,
  leadingIcon,
  ariaLabel,
  menuAriaLabel,
  children,
  className,
  modal,
}: SplitButtonProps) {
  return (
    <div className={cn('tw:inline-flex tw:items-stretch tw:gap-px', className)}>
      <Button
        rank={rank}
        color={color}
        size={size}
        leadingIcon={leadingIcon}
        ariaLabel={ariaLabel}
        onClick={onClick}
        className="tw:flex-1 tw:justify-center tw:rounded-r-none"
      >
        {label}
      </Button>
      <DropdownMenu modal={modal}>
        <DropdownMenuTrigger asChild>
          <Button
            rank={rank}
            color={color}
            size={size}
            leadingIcon="chevron-down"
            ariaLabel={menuAriaLabel}
            className="tw:rounded-l-none tw:px-2"
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:min-w-52">
          {children}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
